import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router} from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { ConsultationUrl } from '../../shared/urls/consultation.url';
import { PatientUrl } from '../../shared/urls/patient.url';
import { BaseService } from '../../shared/services/base.service';
import { RouterModule } from '@angular/router';
import { Utility } from '../../common/utility';

@Injectable()
export class ConsultationProcessService {
    private actionSubject = new Subject<any>();
    private stepSubject = new Subject<any>();
    private tripSubject = new Subject<any>();
    private patientInfoSubject = new Subject<any>();

    constructor(public baseService: BaseService,
                private router: Router) { }
    /**
     * diapatch event when user click on prev or next button
     * @param data : Object {stepUrl: string, isNext: boolean}
     */
    announceAction(data: any) {
        this.actionSubject.next(data);
    }

    /**
    * get message user click on prev or next button
    * @param data : prev, next
    */
    getAction(): Observable<any> {
        return this.actionSubject.asObservable();
    }

    /**
     * diapatch event
     * @param step : ConsultationStep
     */
    announceStep(data: any) {
        this.stepSubject.next(data);
    }

    /**
    * get message user click on prev or next button
    * @param step : ConsultationStep
    */
    getStep(): Observable<any> {
        return this.stepSubject.asObservable();
    }

     /**
     * diapatch event
     * @param data : Object
     */
    announcePatientInfo(data: any) {
        this.patientInfoSubject.next(data);
    }

    /**
    * get message user click on prev or next button
    * @param patient Info : Object
    */
    getPatientInfo(): Observable<any> {
        return this.patientInfoSubject.asObservable();
    }

    getPatientData(id) {
        const url = PatientUrl.GET_PATIENT_ACCOUNT.replace("{id}", id);
        return this.baseService.getData(url, null);
    }

    getConsultationStep(consultationId) {
        const url = ConsultationUrl.GET_CONSULTATION_STEP.replace('{consultationId}', consultationId);
        return this.baseService.getData(url);
    }

    getGroupConsultationStep(consultationId) {
        const url = ConsultationUrl.GET_GROUP_STEP.replace('{groupConsultationId}', consultationId);
        return this.baseService.getData(url);
    }

    moveToNextStep(consultationId, currentStep){
        const url = ConsultationUrl.MOVE_TO_NEXT_STEP.replace('{consultationId}', consultationId).replace("{currentStep}", currentStep);
        return this.baseService.update(url, null);
    }

    beginConsultationProcess(consultationId) {
        const url = ConsultationUrl.CONSULTATION_PROCESS.replace('{consultationId}', consultationId);
        return this.baseService.postData(url, null);
    }

    changeStatus(id) {
        const url = Utility.stringFormat(ConsultationUrl.SET_ADMINISTER_VACCINE_STATUS, [id]);
        return this.baseService.postData(url, null);
    }

    /**
     * get Trip information to show in consultation process
     * @param id : consultation id
     */
    getTripInfo(id) {
        const url = Utility.stringFormat(ConsultationUrl.GET_TRIP_INFORMATION, [id]);
        return this.baseService.get(url);
    }

        /**
     * get Trip information Group to show in consultation process
     * @param groupconsultationId : consultation group id
     */
    getTripInformationGroup(groupconsultationId) {
      const informationUrl = ConsultationUrl.GET_TRIP_INFORMATION_GROUP.replace('{groupConsultationId}', groupconsultationId);
      return this.baseService.getData(informationUrl);
    }

    /**
     * diapatch event when user click on trip information or trip mode button
     * @param data : Object {data: tripInfo or tripMode}
     */
    announceTripAction(data: any) {
        this.tripSubject.next(data);
    }

    /**
    * get message user click on trip information or trip mode button
    */
    getTripAction(): Observable<any> {
        return this.tripSubject.asObservable();
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/consultation-process.service.ts